/** Pixen Intrigue — English overrides for the dashboard feature. Courtly-fae voice. */
export const dashboardPixEn = {
  // DashboardPage
  'dashboard.seo.title': 'My Court',
  'dashboard.seo.description': 'Your favors, claims, contributions, and courtiers in Pixen Intrigue.',
  'dashboard.displayNameFallback': 'Courtier',
  'dashboard.loading': 'Gathering your intrigues…',

  // DashboardPage — Coins card
  'dashboard.coins.title': 'Court Favors',

  // DashboardPage — Contributions card
  'dashboard.contributions.empty': 'No contributions yet — pen your first.',

  // DashboardPage — Claims card
  'dashboard.claims.empty': 'You hold no favor in the Court yet.',

  // DashboardPage — Characters card
  'dashboard.characters.empty': 'No courtiers bound to your name.',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.description': 'Shape the face you show the Court.',
  'dashboard.avatarEditor.errorNameRequired': 'A name is required, even behind a mask.',
  'dashboard.avatarEditor.backstoryPlaceholder': 'What debt do you carry, and who holds it over you?',
  'dashboard.avatarEditor.publicHidden': 'Hidden from the rest of the Court.',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Checkout is not available yet — the ledger remains sealed.',
  'dashboard.coinHistory.seo.title': 'Court Favors',
  'dashboard.coinHistory.seo.description': 'Your full favor ledger, top-ups, and the currency of the Court.',
  'dashboard.coinHistory.heading': 'Court Favors',
  'dashboard.coinHistory.summoningCheckout': 'Opening the ledger…',
  'dashboard.coinHistory.tallyingLedger': 'Tallying favors and debts…',

  // ContributionsPage
  'dashboard.contributionsPage.seo.description':
    "The lore you have recorded, and its passage through the Court's review.",
  'dashboard.contributionsPage.loading': 'Unsealing your dossiers…',
  'dashboard.contributionsPage.empty': 'You have recorded no lore yet. Begin your first contribution.',
}
